var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGoogleDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:location-on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9997 16C16.733 16 17.361 15.7386 17.8837 15.216C18.4055 14.6942 18.6663 14.0666 18.6663 13.3333C18.6663 12.6 18.4055 11.972 17.8837 11.4493C17.361 10.9275 16.733 10.6666 15.9997 10.6666C15.2663 10.6666 14.6388 10.9275 14.117 11.4493C13.5943 11.972 13.333 12.6 13.333 13.3333C13.333 14.0666 13.5943 14.6942 14.117 15.216C14.6388 15.7386 15.2663 16 15.9997 16ZM15.9997 29.3333C12.4219 26.2888 9.7499 23.4608 7.98367 20.8493C6.21656 18.2386 5.33301 15.8222 5.33301 13.6C5.33301 10.2666 6.40545 7.61107 8.55034 5.63329C10.6943 3.65551 13.1775 2.66663 15.9997 2.66663C18.8219 2.66663 21.305 3.65551 23.449 5.63329C25.5939 7.61107 26.6663 10.2666 26.6663 13.6C26.6663 15.8222 25.7832 18.2386 24.017 20.8493C22.2499 23.4608 19.5775 26.2888 15.9997 29.3333Z",
    fill: "#DADADA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGoogleDropdown);
export default __webpack_public_path__ + "static/media/location-google-dropdown.d54b85fa73346323c7e40876da5c6ee3.svg";
export { ForwardRef as ReactComponent };